export function waitForFieldUpdate<ResponseType>({
    errorText,
    isEqual,
    current,
    promiseFactory,
}: {
    errorText: string
    isEqual: (last: ResponseType, current: Partial<ResponseType>) => boolean
    current: Partial<ResponseType>
    promiseFactory: () => Promise<ResponseType>
}): Promise<ResponseType> {
    let attempt = 0
    const promiseWithMethods: {
        resolve: (value: ResponseType) => void
        reject: (reason?: unknown) => void
        promise: Promise<ResponseType>
    } = {
        resolve: () => undefined,
        reject: () => undefined,
        promise: new Promise((resolve, reject) => {
            promiseWithMethods.resolve = resolve
            promiseWithMethods.reject = reject
        }),
    }

    function onResolve(data: ResponseType) {
        if (attempt > 120) {
            promiseWithMethods.reject({
                error: errorText,
            })
        }
        if (!isEqual(data, current)) {
            promiseWithMethods.resolve(data)
        } else {
            ++attempt
            setTimeout(() => {
                promiseFactory().then(onResolve, promiseWithMethods.reject)
            }, 1000)
        }
    }

    promiseFactory().then(onResolve, promiseWithMethods.reject)
    return promiseWithMethods.promise
}
